module.exports = __webpack_public_path__ + "img/Certificate_pic03.b7babcea.png";